import { z } from "zod/v3";

export const BrandCoAgentInputSchema = z.object({
  brandName: z.string().min(1),
  description: z.string().min(1),
  genre: z.string().min(1),
  styleReference: z.string().optional(),
  industry: z.string().optional(),
  website: z.string().url().optional(),
  competitors: z.array(z.string()).optional(),
});
export type BrandCoAgentInput = z.infer<typeof BrandCoAgentInputSchema>;

export const BRAND_PIPELINE_STEPS = [
  { label: "Brand Input", icon: "brand-step-input", service: "User Input" }, // 0
  { label: "Market Research", icon: "brand-step-research", service: "Multi-Engine + Gemini Pro" }, // 1
  { label: "Brand Strategy", icon: "brand-step-strategy", service: "Gemini Pro" }, // 2
  { label: "Brand Identity", icon: "brand-step-identity", service: "Gemini Pro" }, // 3
  { label: "Logo Generation", icon: "brand-step-logo", service: "Gemini Pro" }, // 4
  { label: "Brand Assets", icon: "brand-step-icons", service: "Gemini Pro" }, // 5
  { label: "Brand Deck", icon: "brand-step-deck", service: "System" }, // 6
];
